import * as Yup from "yup";
import { FilterOptionsEnum } from "../enrollmentRulesUtils";

export const msGraphRules = Yup.object().shape({
  rules: Yup.array().of(
    Yup.object({
      value: Yup.lazy((value) =>
        typeof value === "object"
          ? Yup.object().when("filter", (_, schema) => {
              if (value) {
                return Yup.object({
                  from: Yup.date().required("Start date is required").typeError("Invalid date"),
                  to: Yup.date()
                    .required("End date is required")
                    .typeError("Invalid date")
                    .when("from", ([from], to) =>
                      from && !isNaN(Date.parse(from)) ? to.min(from, "End date must be greater than start date") : to,
                    ),
                });
              }
              return schema;
            })
          : Yup.string()
              .required("Please enter value for the rule")
              .when("filter", ([filter], schema) => {
                if (value) {
                  if (filter === FilterOptionsEnum.IsOnOrAfter || filter === FilterOptionsEnum.IsOnOrBefore) {
                    return Yup.string().test("date-validation", "Invalid date", () => !isNaN(Date.parse(value)));
                  }
                }
                return schema;
              }),
      ),
    }),
  ),
});
